import { ISuggestionEntryMixin } from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/__internal__/Interfaces";
import {
  getTrendingSearchesHeader,
  getRecentSearchesHeader,
  getNaturalLanguageSearchEmptyStateHeader,
  RESULT_DROPDOWN_SVG_ICON_PROPS,
} from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/consts";
import {
  IResultDropdownImageSearchItemProps,
  ResultDropdownImageSearchItem,
} from "@faire/deprecated-retailer-visitor-shared/components/TopSearch/ResultDropdown/ResultDropdownImageSearchItem";
import { Search } from "@faire/slate/icons/Search";
import { optimizeImageUrl } from "@faire/web/common/images/optimizeImages";
import { useStrictLocalization } from "@faire/web/common/localization";

interface IEmptyStateItemComponentProps {
  sectionHeader: string;
  suggestion: ISuggestionEntryMixin;
  onHover: () => void;
  onMouseLeave: () => void;
  onClick: () => void;
  onDelete: () => void;
  selected: number;
  indx: number;
  shouldEnableSuggestionsImpressionAllocationV2: boolean;
}

export const EmptyStateSections = ({
  sectionHeader,
  suggestion,
  onHover,
  onMouseLeave,
  onClick,
  onDelete,
  selected,
  indx,
  shouldEnableSuggestionsImpressionAllocationV2,
}: IEmptyStateItemComponentProps) => {
  const { strictLocalize } = useStrictLocalization();
  const key = suggestion.url + indx.toString();

  const itemProps: IResultDropdownImageSearchItemProps = {
    selected: indx === selected,
    suggestion,
    onHover,
    onMouseLeave,
    onClick,
  };

  if (sectionHeader === getTrendingSearchesHeader(strictLocalize)) {
    itemProps.image = optimizeImageUrl(
      { url: suggestion.searchData?.image?.url },
      false,
      { height: 40, width: 40, resizeMethod: "fill" }
    );
  }

  if (sectionHeader === getRecentSearchesHeader(strictLocalize)) {
    itemProps.onDelete = onDelete;
  }

  if (
    sectionHeader === getNaturalLanguageSearchEmptyStateHeader(strictLocalize)
  ) {
    itemProps.image = <Search {...RESULT_DROPDOWN_SVG_ICON_PROPS} />;
    itemProps.reverseHighlightText = "";
    itemProps.shouldEnableSuggestionsImpressionAllocationV2 =
      shouldEnableSuggestionsImpressionAllocationV2;
  }

  return <ResultDropdownImageSearchItem key={key} {...itemProps} />;
};
